import { render, staticRenderFns } from "./Feats.vue?vue&type=template&id=86958f38&scoped=true&"
import script from "./Feats.vue?vue&type=script&lang=js&"
export * from "./Feats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86958f38",
  null
  
)

export default component.exports